<template>
  <base-container>
    <iframe
      height="98%"
      width="99%"
      scrolling="no"
      src="http://114.55.107.63:8011/"
    ></iframe>
  </base-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style>
</style>